import type { UseFormRegister, FieldErrors } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Wallet, CreditCard } from "lucide-react";
import { Input } from "@/components/ui";
import type { LegalFieldPolicy } from "@/services/profileService";
import type { ProfileFormValues } from "./profileFormTypes";
import { isFieldOptional } from "./profileFormTypes";
import type { ProfileSectionControls } from "./profileSectionTypes";
import { ProfileSectionCard } from "./ProfileSectionCard";

interface PaymentSectionProps {
  register: UseFormRegister<ProfileFormValues>;
  errors?: FieldErrors<ProfileFormValues>;
  fieldPolicy: LegalFieldPolicy;
  section: ProfileSectionControls;
}

export function PaymentSection({
  register,
  errors,
  fieldPolicy,
  section,
}: PaymentSectionProps) {
  const { t } = useTranslation("settings");
  const paymentRequired =
    !isFieldOptional(fieldPolicy, "iban") ||
    !isFieldOptional(fieldPolicy, "account_holder");

  return (
    <ProfileSectionCard
      title={t("forms.payment.cardTitle")}
      icon={Wallet}
      {...section}
    >
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
        <Input
          {...register("iban")}
          label={
            paymentRequired
              ? t("forms.payment.iban")
              : t("forms.payment.ibanOptional")
          }
          required={paymentRequired}
          placeholder={t("forms.payment.ibanPh")}
          leftIcon={<CreditCard className="h-4 w-4" />}
          error={errors?.iban?.message}
          hint={t("forms.payment.ibanHint")}
        />
        <Input
          {...register("account_holder")}
          label={
            paymentRequired
              ? t("forms.payment.accountHolder")
              : t("forms.payment.accountHolderOptional")
          }
          required={paymentRequired}
          placeholder={t("forms.payment.accountHolderPh")}
          error={errors?.account_holder?.message}
          hint={t("forms.payment.accountHolderHint")}
        />
      </div>
    </ProfileSectionCard>
  );
}
